const DELAY = 5000;
export default class DetailScene {
    constructor(model, updateItem) {
        this.updateData(model, updateItem);

        this.refreshTimeout = undefined;
    }

    updateData(model, updateItem) {
        this.model = model;
        this.updateItem = updateItem;
    }

    setRefreshOnProgramEnd() {
        this.removeRefreshOnProgramEnd();
        const { model, updateItem } = this;
        const { item } = model;

        // We have nothing to set if item has no end time
        if (!item?.data || !item?.data.end) return;

        // refresh from live to non-playable archive
        if (model.canBePlayed) {
            const timeTillEnd = item.data.end - Date.now();
            if (timeTillEnd > 0) {
                this.refreshTimeout = setTimeout(() => {
                    updateItem(item);
                }, timeTillEnd + DELAY);
            }
            // refresh from non-playable to playable archive (archive is playable after 15 mins)
        } else {
            const fifteenMins = 1000 * 60 * 15;
            const timeTillArchive = item.data.end + fifteenMins - Date.now();
            if (timeTillArchive > 0) {
                this.refreshTimeout = setTimeout(() => {
                    updateItem(item);
                }, timeTillArchive + DELAY);
            }
        }
    }

    removeRefreshOnProgramEnd() {
        if (this.refreshTimeout) clearTimeout(this.refreshTimeout);
        this.refreshTimeout = undefined;
    }
}
